<template>
  <div>
    <el-upload
      ref="uploadRef"
      action="#"
      list-type="picture-card"
      :file-list="imageUrl ? [{ url: imageUrl }] : []"
      :on-change="handleImageChange"
      :on-remove="handleImageRemove"
      :on-preview="handlePreview"
      :auto-upload="false"
      :limit="1"
      :class="{ 'hide-upload': !!imageUrl }"
    >
      <div class="upload-custom-content">
        <i class="el-icon-plus"></i>
        <div class="upload-text">一次上传1张图片</div>
      </div>
    </el-upload>
    <el-dialog
      :visible.sync="dialogVisible"
      append-to-body
      custom-class="dialogImage"
    >
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    value: String, // 接收父组件传入的字符串格式图片URL
  },
  data() {
    return {
      imageUrl: this.value || "", // 初始化时使用props的值
      dialogVisible: false, // 控制预览弹窗的显示
      dialogImageUrl: "", // 预览的图片URL
    };
  },

  mounted() {},
  watch: {
    value(newVal) {
      this.imageUrl = newVal; // 监听外部值变化
    },
  },
  methods: {
    // 图片处理
    handleImageChange(file) {
      // 验证图片大小和类型
      const isJPG =
        file.raw.type === "image/jpeg" || file.raw.type === "image/png";
      const isLt2M = file.raw.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error("上传图片只能是 JPG/PNG 格式!");
        return false;
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
        return false;
      }
      // 读取图片为Base64字符串
      const reader = new FileReader();
      reader.onload = (e) => {
        this.imageUrl = e.target.result;
        this.$emit("input", this.imageUrl); // 使用v-model兼容
        this.$emit("change", this.imageUrl); // 同时触发change事件
      };
      reader.readAsDataURL(file.raw);
      return false; // 手动上传
    },

    handleImageRemove() {
      this.imageUrl = "";
      this.$emit("input", ""); // 清空时发送空字符串
      this.$emit("change", "");
    },
    handlePreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    reset() {
      this.imageUrl = ""; // 重置为字符串空值
      if (this.$refs.uploadRef) {
        this.$refs.uploadRef.clearFiles(); // 清除上传组件内部状态
      }
      this.$emit("input", "");
      this.$emit("change", "");
    },
  },
};
</script>

<style lang="scss" scoped>
.upload-custom-content {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.upload-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  margin-top: 15px;
  font-size: 12px;
  color: #8c939d;
  width: 100%;
  text-align: center;
}

.el-icon-plus {
  font-size: 28px;
  color: #8c939d;
  margin-top: -10px;
}

/* 隐藏上传框的样式 */
.hide-upload ::v-deep .el-upload--picture-card {
  display: none;
}

/* 限制上传文件类型的提示 */
.el-upload__tip {
  color: #f56c6c;
  font-size: 12px;
  text-align: center;
  margin-top: 5px;
}
.el-upload-list--picture-card .el-upload-list__item {
  width: 15rem;
  height: 15rem;
}

// 解决上传图片时，图片往下跑一下的问题
::v-deep .el-upload--picture-card {
  height: 148px; /* 与列表项高度一致 */
  line-height: 148px; /* 垂直居中 */
  margin-bottom: 0; /* 移除默认间距 */
}

::v-deep .el-upload-list--picture-card .el-upload-list__item {
  height: 148px;
  transition: none; /* 禁用过渡效果 */
}
::v-deep .el-upload-list--picture-card {
  .el-upload-list__item {
    transition: none !important;
  }
}
::v-deep .dialogImage .el-dialog__body {
  height: 60vh !important;
}
::v-deep .dialogImage .el-dialog__body img {
  width: 100%;
  height: 100%;
}
</style>
